var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Tweet',{attrs:{"user":_vm.user}}),_c('div',{staticClass:"main"},[_c('ShowTweets',{attrs:{"tweetsData":_vm.feedData,"showName":_vm.showName}}),_c('br'),_c('br'),_c('br')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }